
import { defineComponent, onBeforeMount, inject, computed } from 'vue'
import RecipeStore from '@/store'

import MealLists from '@/components/recipe/Search/MealLists.vue'
import SideBar from '@/components/recipe/Search/SideBar.vue'
import Contact from '@/components/recipe/Home/Contact.vue'

export default defineComponent({
  name: 'SearchResult',
  components: {
    MealLists,
    SideBar,
    Contact
  },
  setup () {
    const store = inject('store', RecipeStore)
    onBeforeMount(async () => {
      await store.GET_CATEGORY()
    })

    const searchName = computed(() => {
      return store.getters.getSearchName
    })

    return {
      searchName
    }
  }
})
